export const DEFAULT_MAP_VIEW = {
  center: [50.073, 14.466],
  zoom: 13,
};

const STORAGE_KEY = "electionmap.sectionViewports.v1";

function isFiniteNumber(value) {
  return Number.isFinite(Number(value));
}

function normalizeCenter(center) {
  if (Array.isArray(center) && center.length >= 2 && isFiniteNumber(center[0]) && isFiniteNumber(center[1])) {
    return [Number(center[0]), Number(center[1])];
  }
  if (center && isFiniteNumber(center.lat) && isFiniteNumber(center.lng)) {
    return [Number(center.lat), Number(center.lng)];
  }
  return null;
}

export function normalizeViewport(viewport) {
  if (!viewport || typeof viewport !== "object") return null;
  const center = normalizeCenter(viewport.center);
  const zoom = Number(viewport.zoom);
  if (!center || !Number.isFinite(zoom)) return null;
  return { center, zoom };
}

export function getViewportStorageKey(sectionKey, areaId) {
  return `${String(sectionKey || "map")}:${String(areaId || "none")}`;
}

function readViewportStore() {
  if (typeof window === "undefined" || !window.localStorage) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
}

export function readStoredViewport(sectionKey, areaId) {
  const store = readViewportStore();
  return normalizeViewport(store[getViewportStorageKey(sectionKey, areaId)]);
}

export function writeStoredViewport(sectionKey, areaId, viewport) {
  const normalized = normalizeViewport(viewport);
  if (!normalized || typeof window === "undefined" || !window.localStorage) return;
  try {
    const store = readViewportStore();
    store[getViewportStorageKey(sectionKey, areaId)] = {
      ...normalized,
      updatedAt: Date.now(),
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (_) {
    // Local storage is best-effort only.
  }
}

export function clearStoredViewport(sectionKey, areaId) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    const store = readViewportStore();
    delete store[getViewportStorageKey(sectionKey, areaId)];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (_) {
    // Local storage is best-effort only.
  }
}

export function getInitialMapView(sectionKey, areaId) {
  return readStoredViewport(sectionKey, areaId) || DEFAULT_MAP_VIEW;
}

export function getMapViewport(map) {
  if (!map || typeof map.getCenter !== "function" || typeof map.getZoom !== "function") return null;
  try {
    return normalizeViewport({
      center: map.getCenter(),
      zoom: map.getZoom(),
    });
  } catch (_) {
    return null;
  }
}

export function makeAutoFitRequestKey(sectionKey, areaId, reason = "auto") {
  return `${String(sectionKey || "map")}:${String(areaId || "none")}:${String(reason)}:${Date.now()}`;
}
